export const ParticipationLevel = {
    READ: 1,
    WRITE: 2
}